import request from '@/utils/main/request';
import { apiError } from '@/utils/main/common';

const ajax = {};
const postSwitch = {};

ajax.get = async function ajaxGet(url, data) {
    return request.send({
        url,
        method: 'get',
        data,
    }).then((result) => {
        if (apiError(result)) {
            throw apiError(result);
        }
        return result;
    }).catch(() => {
        throw new Error('系统异常');
    });
};
ajax.post = async function ajaxPost(url, data) {
    if (postSwitch[url]) {
        throw new Error('this request is posting!');
    }
    postSwitch[url] = true;
    return request.send({
        url,
        method: 'post',
        data,
    }).catch(() => {
        postSwitch[url] = null;
        throw new Error('系统异常');
    }).then((result) => {
        postSwitch[url] = null;
        if (apiError(result)) {
            throw apiError(result);
        }
        return result;
    });
};
ajax.getErrorMsg = (err) => {
    if (!err) {
        return false;
    }
    const msgArr = [];
    Object.keys(err).forEach((v) => {
        err[v].errors.forEach((rule) => {
            msgArr.push(rule.message);
        });
    });
    return msgArr;
};
ajax.alert = (err, feedback) => {
    const msgArr = ajax.getErrorMsg(err);
    if (msgArr) {
        feedback({ title: msgArr[0] });
    }
};
ajax.toast = (err, feedback) => {
    const msgArr = ajax.getErrorMsg(err);
    if (msgArr) {
        msgArr.forEach((msg) => {
            feedback(msg);
        });
    }
};
ajax.notice = (err, feedback) => {
    const msgArr = ajax.getErrorMsg(err);
    if (msgArr) {
        msgArr.forEach((msg) => {
            feedback({ message: msg });
        });
    }
};

export default ajax;
